
// import React, { useState, useEffect, useRef } from "react";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// // import "./DateRangeFilter.css";

// interface DateRangeFilterProps {
//   onChange: (from: string, to: string) => void;
//   onClose: () => void;
//   initialFrom: string;
//   initialTo: string;
// }

// const DateRangeFilter: React.FC<DateRangeFilterProps> = ({ onChange, onClose, initialFrom, initialTo }) => {
//   const filterRef = useRef<HTMLDivElement>(null);

//   const parseDate = (dateString: string) => (dateString ? new Date(dateString) : null);

//   // State for "From" date and time
//   const [fromDate, setFromDate] = useState<Date | null>(parseDate(initialFrom));
//   const [fromTime, setFromTime] = useState<Date | null>(parseDate(initialFrom));

//   // State for "To" date and time
//   const [toDate, setToDate] = useState<Date | null>(parseDate(initialTo));
//   const [toTime, setToTime] = useState<Date | null>(parseDate(initialTo));

//   useEffect(() => {
//     setFromDate(parseDate(initialFrom));
//     setFromTime(parseDate(initialFrom));
//     setToDate(parseDate(initialTo));
//     setToTime(parseDate(initialTo));
//   }, [initialFrom, initialTo]);

//   // ✅ Close on outside click
//   useEffect(() => {
//     const handleClickOutside = (event: MouseEvent) => {
//       if (filterRef.current && !filterRef.current.contains(event.target as Node)) {
//         onClose();
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, [onClose]);

//   // ✅ Combine date and time into a single Date object
//   const combineDateTime = (date: Date | null, time: Date | null) => {
//     if (!date || !time) return null;
//     return new Date(
//       date.getFullYear(),
//       date.getMonth(),
//       date.getDate(),
//       time.getHours(),
//       time.getMinutes(),
//       0
//     );
//   };

//   // ✅ Format to ISO string without timezone shift
//   const formatToISOWithoutTimezoneShift = (date: Date) => {
//     return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
//       date.getDate()
//     ).padStart(2, "0")}T${String(date.getHours()).padStart(2, "0")}:${String(
//       date.getMinutes()
//     ).padStart(2, "0")}:${String(date.getSeconds()).padStart(2, "0")}`;
//   };

//   const handleApply = () => {
//     const fromDateTime = combineDateTime(fromDate, fromTime);
//     const toDateTime = combineDateTime(toDate, toTime);

//     if (fromDateTime && toDateTime) {
//       // ✅ Pass formatted ISO string without timezone shift
//       onChange(formatToISOWithoutTimezoneShift(fromDateTime), formatToISOWithoutTimezoneShift(toDateTime));
//     }
//     onClose();
//   };

//   // ✅ Fixed quick select logic
//   const quickSelect = (daysOffset: number) => {
//     const targetDate = new Date();
//     targetDate.setDate(targetDate.getDate() + daysOffset);

//     // ✅ Set fromDate to start of the day (00:00:00)
//     const fromDate = new Date(
//       targetDate.getFullYear(),
//       targetDate.getMonth(),
//       targetDate.getDate(),
//       0, 0, 0
//     );

//     // ✅ Set toDate to end of the day (23:59:59)
//     const toDate = new Date(
//       targetDate.getFullYear(),
//       targetDate.getMonth(),
//       targetDate.getDate(),
//       23, 59, 59
//     );

//     setFromDate(fromDate);
//     setFromTime(fromDate); // ✅ Use same date object for time
//     setToDate(toDate);
//     setToTime(toDate); // ✅ Use same date object for time
//   };

//   return (
//     <div className="date-filter" ref={filterRef}>
//       {/* FROM Section */}
//       <div className="date-time-picker">
//         <label>From:</label>
//         <div className="picker-group">
//           <DatePicker
//             selected={fromDate}
//             onChange={(date) => setFromDate(date)}
//             dateFormat="yyyy-MM-dd"
//             placeholderText="Select date"
//           />
//           <DatePicker
//   selected={fromTime}
//   onChange={(time) => setFromTime(time)}
//   showTimeSelect
//   showTimeSelectOnly
//   timeIntervals={1}
//   timeCaption="Time"
//   timeFormat="HH:mm" // ✅ 24-hour format
//   dateFormat="HH:mm"
//   placeholderText="Select time"
// />

//         </div>
//       </div>

//       {/* TO Section */}
//       <div className="date-time-picker">
//         <label>To:</label>
//         <div className="picker-group">
//           <DatePicker
//             selected={toDate}
//             onChange={(date) => setToDate(date)}
//             dateFormat="yyyy-MM-dd"
//             placeholderText="Select date"
//           />
//           <DatePicker
//   selected={toTime}
//   onChange={(time) => setToTime(time)}
//   showTimeSelect
//   showTimeSelectOnly
//   timeIntervals={1}
//   timeCaption="Time"
//   timeFormat="HH:mm" // ✅ 24-hour format
//   dateFormat="HH:mm"
//   placeholderText="Select time"
// />

//         </div>
//       </div>

//       {/* Quick Select Buttons */}
//       <div className="quick-select">
//         <button onClick={() => quickSelect(-1)}>Yesterday</button>
//         <button onClick={() => quickSelect(0)}>Today</button>
//         <button onClick={() => quickSelect(1)}>Tomorrow</button>
//         <button onClick={() => quickSelect(2)}>Day After Tomorrow</button>
//       </div>

//       {/* Action Buttons */}
//       <div className="filter-actions">
//         <button className="apply-btn" onClick={handleApply}>
//           Apply
//         </button>
//         <button
//           className="clear-btn"
//           onClick={() => {
//             setFromDate(null);
//             setFromTime(null);
//             setToDate(null);
//             setToTime(null);
//             onChange("", "");
//           }}
//         >
//           Clear
//         </button>
//       </div>
//     </div>
//   );
// };

// export default DateRangeFilter;







import React, { useState, useEffect, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

interface DateRangeFilterProps {
  onChange: (from: string, to: string) => void;
  onClose: () => void;
  initialFrom: string;
  initialTo: string;
}

const DateRangeFilter: React.FC<DateRangeFilterProps> = ({
  onChange,
  onClose,
  initialFrom,
  initialTo,
}) => {
  const filterRef = useRef<HTMLDivElement>(null);

  const parseDate = (dateString: string) => (dateString ? new Date(dateString) : null);

  const [fromDate, setFromDate] = useState<Date | null>(parseDate(initialFrom));
  const [fromTime, setFromTime] = useState<Date | null>(parseDate(initialFrom));
  const [toDate, setToDate] = useState<Date | null>(parseDate(initialTo));
  const [toTime, setToTime] = useState<Date | null>(parseDate(initialTo));

  useEffect(() => {
    setFromDate(parseDate(initialFrom));
    setFromTime(parseDate(initialFrom));
    setToDate(parseDate(initialTo));
    setToTime(parseDate(initialTo));
  }, [initialFrom, initialTo]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (filterRef.current && !filterRef.current.contains(event.target as Node)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  const combineDateTime = (date: Date | null, time: Date | null) => {
    if (!date || !time) return null;
    return new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      time.getHours(),
      time.getMinutes(),
      0
    );
  };

  const formatToISOWithoutTimezoneShift = (date: Date) => {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
      date.getDate()
    ).padStart(2, "0")}T${String(date.getHours()).padStart(2, "0")}:${String(
      date.getMinutes()
    ).padStart(2, "0")}:${String(date.getSeconds()).padStart(2, "0")}`;
  };

  const handleApply = () => {
    const fromDateTime = combineDateTime(fromDate, fromTime);
    const toDateTime = combineDateTime(toDate, toTime);
    if (fromDateTime && toDateTime) {
      onChange(formatToISOWithoutTimezoneShift(fromDateTime), formatToISOWithoutTimezoneShift(toDateTime));
    }
    onClose();
  };

  const quickSelect = (daysOffset: number) => {
    const targetDate = new Date();
    targetDate.setDate(targetDate.getDate() + daysOffset);
    const from = new Date(targetDate.getFullYear(), targetDate.getMonth(), targetDate.getDate(), 0, 0, 0);
    const to = new Date(targetDate.getFullYear(), targetDate.getMonth(), targetDate.getDate(), 23, 59, 59);
    setFromDate(from);
    setFromTime(from);
    setToDate(to);
    setToTime(to);
  };

  return (
    <div
      ref={filterRef}
      className="p-4 w-72 rounded-lg border border-gray-200 shadow-md bg-white text-sm space-y-4"
    >
      {/* FROM Section */}
      <div>
        <label className="block text-gray-700 font-medium mb-1">From</label>
        <div className="flex space-x-2">
          <DatePicker
            selected={fromDate}
            onChange={(date) => setFromDate(date)}
            dateFormat="yyyy-MM-dd"
            placeholderText="Date"
            className="w-full border rounded-md px-2 py-1 text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-300"
          />
          <DatePicker
            selected={fromTime}
            onChange={(time) => setFromTime(time)}
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={1}
            timeCaption="Time"
            timeFormat="HH:mm"
            dateFormat="HH:mm"
            placeholderText="Time"
            className="w-full border rounded-md px-2 py-1 text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-300"
          />
        </div>
      </div>

      {/* TO Section */}
      <div>
        <label className="block text-gray-700 font-medium mb-1">To</label>
        <div className="flex space-x-2">
          <DatePicker
            selected={toDate}
            onChange={(date) => setToDate(date)}
            dateFormat="yyyy-MM-dd"
            placeholderText="Date"
            className="w-full border rounded-md px-2 py-1 text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-300"
          />
          <DatePicker
            selected={toTime}
            onChange={(time) => setToTime(time)}
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={1}
            timeCaption="Time"
            timeFormat="HH:mm"
            dateFormat="HH:mm"
            placeholderText="Time"
            className="w-full border rounded-md px-2 py-1 text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-300"
          />
        </div>
      </div>

      {/* Quick Select Buttons */}
      <div className="grid grid-cols-2 gap-2">
        <button
          onClick={() => quickSelect(-1)}
          className="px-3 py-1 text-gray-700 border rounded-md hover:bg-indigo-50"
        >
          Yesterday
        </button>
        <button
          onClick={() => quickSelect(0)}
          className="px-3 py-1 text-gray-700 border rounded-md hover:bg-indigo-50"
        >
          Today
        </button>
        <button
          onClick={() => quickSelect(1)}
          className="px-3 py-1 text-gray-700 border rounded-md hover:bg-indigo-50"
        >
          Tomorrow
        </button>
        <button
          onClick={() => quickSelect(2)}
          className="px-3 py-1 text-gray-700 border rounded-md hover:bg-indigo-50"
        >
          Day After
        </button>
      </div>

      {/* Action Buttons */}
      <div className="flex justify-end space-x-2">
        <button
          onClick={handleApply}
          className="px-4 py-1 rounded-md bg-indigo-500 text-white hover:bg-indigo-600"
        >
          Apply
        </button>
        <button
          onClick={() => {
            setFromDate(null);
            setFromTime(null);
            setToDate(null);
            setToTime(null);
            onChange("", "");
          }}
          className="px-4 py-1 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100"
        >
          Clear
        </button>
      </div>
    </div>
  );
};

export default DateRangeFilter;
